import {
    toGqlOperation,
    type GqlOperation as WbdGqlOperation,
} from "@khanacademy/wonder-blocks-data";
import {documentNode, type GqlOperation} from "@khan/data-gql-core";

import {asNormalizedOperationString} from "./as-normalized-operation-string.ts";

/**
 * Normalize a simple GqlOperation for use with Wonder Blocks Data.
 *
 * Various steps in this process are cached to improve performance.
 *
 * @param operation The operation to be normalized.
 * @returns The normalized operation.
 */
export const toNormalizedOperation = <
    TData,
    TVariables extends Record<any, any>,
>(
    operation: GqlOperation<TData, TVariables>,
): WbdGqlOperation<TData, TVariables> => {
    const query = asNormalizedOperationString(operation);
    const wbDataOperation: WbdGqlOperation<TData, TVariables> = {
        ...toGqlOperation(documentNode(operation)),
        query,
    };
    return wbDataOperation;
};
